module.exports = __webpack_public_path__ + "img/parents.5dd460df.svg";